"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigmaModelTypeSchema = exports.DatasheetUriSchema = exports.PinoutSchema = void 0;
const z = require("zod");
exports.PinoutSchema = z.record(z.string(), z.array(z.string()));
exports.DatasheetUriSchema = z.string();
exports.SigmaModelTypeSchema = z.string();
//# sourceMappingURL=package-common.js.map